import { nanoid } from 'nanoid';
import { useCallback } from 'react';
import { useAuthManager } from '@funtech-int/yango-shared';

import { useLogger } from '@/shared/hooks/useLogger';

import { emitServiceMetrika } from '../lib/metrika/emitter';

export const useMovieBuyButtonClickHandler = () => {
    const { isAuthorized } = useAuthManager();
    const logger = useLogger();

    return useCallback(() => {
        if (!isAuthorized) {
            return;
        }

        const params = {
            extraOriginParameters: {
                hashOrderId: nanoid(),
            },
        };

        emitServiceMetrika({ target: 'BUY_FILM_BUTTON_CLICK', params, logger });
    }, [isAuthorized, logger]);
};
